import Home from './app/Home/Home';

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
